import { PosListResponse } from './schemas';

export const mockPosList: PosListResponse = {
  result: [
    {
      id: 1,
      name: 'Gamma Ede',
      country: 'Netherlands',
      street: 'Nieuwe Kazernelaan',
      streetNumber: '2',
      city: 'Ede',
      zip: '6711 JC',
    },
    {
      id: 2,
      name: 'Karwei Ede',
      country: 'Netherlands',
      street: 'Industrieweg',
      streetNumber: '15',
      city: 'Ede',
      zip: '6721 LH',
    },
    {
      id: 3,
      name: 'Gamma Lier',
      country: 'Belgium',
      street: 'Mechelsesteenweg',
      streetNumber: '280',
      city: 'Lier',
      zip: '2500',
    },
  ],
  pageSize: 5,
  pageCount: 1,
  rowCount: 5,
};
